<span class="avatar-btn">
    <span #widgetId></span>
</span>